"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "C1Navbar", {
  enumerable: true,
  get: function () {
    return _navbarTypes.C1Navbar;
  }
});
Object.defineProperty(exports, "NavbarArgs", {
  enumerable: true,
  get: function () {
    return _navbarTypes.NavbarArgs;
  }
});
Object.defineProperty(exports, "NavbarItem", {
  enumerable: true,
  get: function () {
    return _navbarTypes.NavbarItem;
  }
});
Object.defineProperty(exports, "User", {
  enumerable: true,
  get: function () {
    return _navbarTypes.User;
  }
});
Object.defineProperty(exports, "WfmConfig", {
  enumerable: true,
  get: function () {
    return _navbarTypes.WfmConfig;
  }
});
exports.getNavItemsForUser = void 0;
var _navbar = require("./navbar");
var _utils = require("./utils");
var _navbarTypes = require("./navbarTypes");
const defaultArgs = {
  enableWfm: false,
  forgerockIdToken: '',
  distributeColumns: false,
  innovationCenterUrl: '',
  showFilteredNavbar: true,
  wfmConfig: {
    navItems: {},
    wfmBaseUrl: ''
  },
  dataLibrary: false,
  legacyBI: true,
  settings: false,
  insights: false,
  showInsightsWithDXPermissions: false,
  defaultRoute: null,
  withinC1: true,
  enableSmartTags: false
};

/**
 * The primary export of c1-navbar
 * @param navbarArgs - An instance of `NavbarArgs` that is passed in by the consumer of `c1-navbar`
 * @returns Navbar item information in a standardized format and ready for use
 */
const getNavItemsForUser = navbarArgs => {
  const args = {
    ...defaultArgs,
    ...navbarArgs
  };
  return (0, _utils.resolveNavbarItems)(Object.values(_navbar.navbarEntries), args);
};
exports.getNavItemsForUser = getNavItemsForUser;
//# sourceMappingURL=index.js.map